module.exports = __webpack_public_path__ + "static/img/instagram.3fcc39b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/instagram.png
// module id = JGRZ
// module chunks = 1